import {
  EQAllowedFrequencies,
  EQAllowedGains,
} from "shared/games/mixpuzzles/types";
import useMeasure from "util/useMeasure";
import EqualizerGraph from "./EqualizerGraph";

export interface Value {
  eq_freq: EQAllowedFrequencies;
  eq_gain: EQAllowedGains;
}

export interface Props {
  readOnly?: boolean;
  value: Value;
  onChange: (value: Value) => void;
  roundedClassName?: string;
}

export default function Equalizer(props: Props) {
  const [{ width, height }, measureRef] = useMeasure<HTMLDivElement>();

  return (
    <div className="absolute inset-0 font-brik" ref={measureRef}>
      <EqualizerGraph {...props} height={height} width={width} />
    </div>
  );
}
